import React,{ Component } from 'react';
import { Link } from 'react-router-dom';

import {
  Button
} from 'reactstrap';

import FloatingWindowLayout from '../../../shared/components/FloatingWindowLayout';
import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import VersionTag from '../../../shared/components/VersionTag';

import { alertSalesTeam } from '../../../shared/utils';
import { ACTIVE_PROFILE } from '../../../config';

class Login extends Component {
  constructor(){
    super();

    this.state = {
      authenticating:false,
      error:null
    };
  }

  handleSubmit(data){
    const { email, password } = data;

    this.setState({authenticating:true});

    this.props.requestAuthTokenWithCredentials(email,password)
      .then(() => this.props.loadActiveUser())
      .then(() => this.loadAgencyForActiveUser())
      .then(() => this.alertSalesTeamIfNeeded())
      .then(() => this.redirectIfSuccessful())
      .catch((err) => this.handleError(err))
  }


  loadAgencyForActiveUser(user){
    const agencyId = this.props.activeUser.agencyId;

    if(agencyId && agencyId.length === 36){
      //IF EXISTS AND IS A VALID GUID
      return this.props.loadAgency(agencyId);
    } else {
      return Promise.resolve();
    }
  }

  alertSalesTeamIfNeeded(){
    const agencyName = this.props.activeUserAgencyName,
      name = `${this.props.activeUser.firstName} ${this.props.activeUser.lastName}`,
      role = this.props.activeUser.isOwner ? 'Admin' : 'Creator',
      email = this.props.activeUser.email;

    if(!this.props.activeUser.isProvider && ACTIVE_PROFILE === 'prod'){
      return alertSalesTeam(name,email,role,agencyName);
    } else {
      return Promise.resolve();
    }
  }

  redirectIfSuccessful(){
    this.setState({authenticating:false});

    if(this.props.redirectedFrom){
      this.props.history.push(this.props.redirectedFrom);
    } else if(this.props.activeUser.isProvider){
      this.props.history.push('/superadmin/accounts');
    } else {
      this.props.history.push('/account/experiences');
    }
  }

  handleError(error){
    this.setState({
      error:error,
      authenticating:false
    });
  }

  render(){
    const {
      environment,
      frontEndVersion,
      backEndVersion
    } = this.props;

    return (
      <div className='FloatingWindowLayoutBackdrop'>
        {ACTIVE_PROFILE !== 'prod' && ( 
          <VersionTag 
            environment={environment}
            frontend={frontEndVersion}
            backend={backEndVersion}
          /> 
        )}  
        <FloatingWindowLayout title='Sign In'>
          {this.state.error && (
            <div className='FormError'>
              <span>Oops! It seems you have entered an invalid email and/or password.</span>
              <br />
              <br />
              <span>Please try again.</span>
            </div>
          )}
          {this.props.message && (
            <div className='FormError'>
              <span>{this.props.message}</span>
            </div>
          )}
          <Form onSubmit={(data) => this.handleSubmit(data)}>
            <TextInput label='Email' name='email' />
            <TextInput label='Password' name='password' hidden type='password' />
            <div>
              <Link to='/reset'>Forgot Password?</Link>
              <Button color='primary' className='float-right'>
                {this.state.authenticating ? 'Signing In' : 'Sign In'}
              </Button>
            </div>
          </Form>    
        </FloatingWindowLayout>
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login/components/Login.js